import { Text, View, Image } from "@react-pdf/renderer";
import styles from "./PdfStyles";

interface PdfHeaderProps {
  title: string;
  imageSrc: string;
  photoDisclaimer: string;
  price: string;
  discount: string;
}

const PdfHeader: React.FC<PdfHeaderProps> = ({
  title,
  imageSrc,
  photoDisclaimer,
  price,
  discount,
}) => {
  return (
    <>
      <Text style={styles.title}>{title} Summary</Text>
      <View style={{ ...styles.row, ...styles.bordered, padding: 20 }}>
        <View style={styles.column}>
          {imageSrc ? <Image src={imageSrc} /> : null}
          <Text style={styles.text}>{photoDisclaimer}</Text>
        </View>

        <View style={styles.column}>
          {price !== "$0.00" ? (
            <>
              <Text style={{ ...styles.text, textTransform: "uppercase" }}>
                Total
              </Text>
              <Text
                style={{ ...styles.price, textAlign: "left", fontSize: "30" }}
              >
                {price}
              </Text>
              <Text
                style={{
                  ...styles.price,
                  color: "#000000",
                  textAlign: "left",
                  fontSize: "16",
                }}
              >
                AVID ADVANTAGE PRICE
              </Text>
            </>
          ) : null}
          {discount !== "$0.00" ? (
            <Text
              style={{
                ...styles.price,
                fontWeight: "normal",
                color: "#5d5d5d",
                textAlign: "left",
                fontSize: "17",
              }}
            >
              {`${discount} MSRP`}
            </Text>
          ) : null}
        </View>
      </View>
    </>
  );
};
export default PdfHeader;
